import { useEffect, useState } from "react";

export function useShouldStackChips(containerRef: React.RefObject<HTMLDivElement | null>) {
  const [shouldStack, setShouldStack] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkOverflow = () => {
      const children = Array.from(el.children) as HTMLElement[];
      const totalWidth = children.reduce((acc, c) => acc + c.offsetWidth, 0);
      const available = el.clientWidth;

      // margem de segurança de 4px
      const overflow = totalWidth > available - 4;

      setShouldStack(overflow);
    };

    // checa imediatamente
    checkOverflow();

    // observa mudanças no tamanho do container
    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(el);

    // observa redimensionamento da janela também
    window.addEventListener("resize", checkOverflow);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [containerRef]);

  return shouldStack;
}

